import React from 'react';

import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';

const STATUS_COLORS: Record<string, { main: string; bg: string; border: string }> = {
  Draft: { main: '#546E7A', bg: '#ECEFF1', border: '#B0BEC5' },
  Translating: { main: '#8A5A00', bg: '#FFF3D6', border: '#F2C56B' },
  Ready: { main: '#006C8F', bg: '#DDF5FF', border: '#7CCDE8' },
  Locked: { main: '#1B6E3C', bg: '#DFF4E7', border: '#80C99B' },
  Failed: { main: '#A32929', bg: '#FDE7E7', border: '#E99A9A' },
};

interface Props {
  status?: string;
}

export default function TranslationCatalogStatusChip({ status }: Props) {
  const value = status || 'unknown';
  const colors = STATUS_COLORS[value];

  return (
    <Chip
      size="small"
      label={value}
      variant="outlined"
      sx={{
        bgcolor: colors?.bg ?? ((theme) => alpha(theme.palette.grey[500], 0.1)),
        color: colors?.main ?? 'text.secondary',
        borderColor: colors?.border ?? 'divider',
        fontWeight: 600,
      }}
    />
  );
}
